// extracted by mini-css-extract-plugin
module.exports = {"collaborators":"science-collaborators-module--collaborators--1-NLn"};